import React, {FC} from 'react'
import {useFormContext, Controller} from 'react-hook-form'

type InputProps = {
  name: string
  disabled?: boolean
  readOnly?: boolean
  onchange?: any
}

const InputCheck: FC<InputProps> = ({
  name,
  disabled = false,
  readOnly = false,
  onchange,
  ...props
}) => {
  const {
    control,
    formState: {errors},
  } = useFormContext()

  return (
    <div className='sdx_form_input'>
      <Controller
        name={name}
        control={control}
        render={({field}) => (
          <input
            className='form-check-input'
            type='checkbox'
            id='switchActivaExpresion'
            checked={field.value}
            disabled={disabled}
            onChange={(e) => {
              console.log(field)
              field.onChange(e)
              if (onchange) return onchange(e)
            }}
          />
        )}
      />
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputCheck
